module.exports = __webpack_public_path__ + "static/media/zurich.9642f298.png";